import { Navigate } from "react-router-dom";


const AuthenticatedRouteCourier = ({ children, isAuthenticated }) => {

	const backUrl = localStorage.getItem("backUrl");

    if (isAuthenticated) {
    	if (backUrl) {
    		localStorage.removeItem("backUrl");
      		return <Navigate to={backUrl} replace />;
    	}
    	else
        	return <Navigate to="/courier/profile/orders" replace />;
    }

    return children;
}

export default AuthenticatedRouteCourier;
